import type { FlightPaxEntry } from "./types";

/**
 * Texto para el campo de observaciones del plan de vuelo en ForeFlight:
 * solo letras, números y espacios. Ej.:
 * "Activo con Santiago en 12240 y cancelo con Serena Radar en 13535
 *  Pax Catalina Valdes 8668117k Camilo Justiniano 105678339"
 *
 * Misma lógica que `foreflightText` en functions/email-templates.js —
 * mantener las dos en sincronía.
 */
export function toPlainAscii(s: string): string {
  return s
    .replace(/(\d)[.,](\d)/g, "$1$2") // 122.40 → 12240
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .replace(/ñ/g, "n")
    .replace(/Ñ/g, "N")
    .replace(/[^A-Za-z0-9 ]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

/** "8.668.117-K" → "8668117k" */
export function rutForForeflight(rut: string): string {
  return rut.replace(/[^0-9kK]/g, "").replace(/K$/, "k");
}

export function buildForeflightText({
  pax,
  origenContacto,
  destinoContacto,
}: {
  pax: FlightPaxEntry[];
  origenContacto: string | null | undefined;
  destinoContacto: string | null | undefined;
}): string {
  const parts: string[] = [];
  const o = origenContacto?.trim();
  const d = destinoContacto?.trim();
  if (o && d) parts.push(`Activo con ${o} y cancelo con ${d}`);
  else if (o) parts.push(`Activo con ${o}`);
  else if (d) parts.push(`Cancelo con ${d}`);
  const paxParts = (pax || [])
    .map((p) => [p.fullName, p.rut ? rutForForeflight(p.rut) : ""].filter(Boolean).join(" ").trim())
    .filter(Boolean);
  if (paxParts.length) parts.push(`Pax ${paxParts.join(" ")}`);
  return toPlainAscii(parts.join(" "));
}
